export default {
  methods: {
    recommendedRentWithOptions({ recommended_rent_fee }) {
      const { value: deposit } = this.recommendedRent.deposit
      const { value: keyMoney } = this.recommendedRent.keyMoney

      return (recommended_rent_fee / (1 + deposit / 48 + keyMoney / 24))
    }
  }
}
